import React from 'react';

const Identification = (props) => {
    return(
        <h1 className="identification">Garzon: {props.usuario}</h1>
    );
}
export default Identification;